<script>

  export default{
    name: 'Website',
    data () {
      return {}
    },
    computed: {},
    mounted () {
    },
    destroyed () {},
    methods: {}
  }
</script>

<template>
    <router-view></router-view>
</template>



// WEBPACK FOOTER //
// Main.vue?63696b7c